/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { Contents } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface ContentServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Returns the content
     * 
     * @param title The title of the content which is looked for
     */
    getContent(title?: string, extraHttpRequestParams?: any): Observable<Contents>;

    /**
     * Returns the content
     * 
     */
    getContentPublic(extraHttpRequestParams?: any): Observable<Contents>;

}
